import styled from "styled-components";
import {
  PurchaseLinkPriceOption,
  PurchaseVariantSelectionType,
} from "../enums";
import { CustomLabel, IOption } from "@mindmemobile/mm-shared-global";

export const priceOptions = [
  {
    label: "Specific prices",
    value: PurchaseLinkPriceOption.Specific,
  } as IOption,
  {
    label: "All active prices",
    value: PurchaseLinkPriceOption.AllActive,
  } as IOption,
];

export const getVariantOptions = (isTrackInventory: boolean) => {
  const variantOptions = [
    {
      label: "Specific variants",
      value: PurchaseVariantSelectionType.SpecificVariants,
    } as IOption,
    {
      label: "All available variants",
      value: PurchaseVariantSelectionType.AllActiveVariants,
    } as IOption,
  ];

  if (isTrackInventory) {
    variantOptions.push({
      label: "All available variants with inventory",
      value: PurchaseVariantSelectionType.AllActiveVariantsWithInventory,
    } as IOption);
  }

  return variantOptions;
};

export const PurchaseLinkPopupWrapper = styled.div`
    /* pl- stands for Purchase Link */
    .pl-header {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        display: inline-block;
        margin-bottom: 20px;
    }
    .pl-input-labels {
        ${CustomLabel} {
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 10px;
            &.pl-no-margin {
                margin-bottom: 0px;
            }
        }
        .styled-input.merchant-inputs {
            width: 300px;
        }
    }
    .label-description-row {
        margin-bottom: 30px;
    }
    .pl-chkbx-panel {
        margin-top: 40px;

        > label {
            font-weight: 600;
            font-size: 18px;
            & + i {
                margin-top: 2px;
                margin-left: 10px;
            }
        }
    }
    .pl-chkbx-flex {
        margin: 0px 0px 40px;
        > div {
            width: 48%;
        }
    }
    .return-days-input {
        margin-left: 0px;
        input {
            height: 26px;
            min-width: 35px;
            max-width: 55px;
            width: auto;
            padding: 2px 0px 2px 5px;
        }
    }
    .pl-last-dropdown {
        margin-bottom: 30px;
    }

    .dpdn-with-icons {
        img {
            height: 20px;
            width: 20px;
        }
    }
    .pl-advance-section {
        > label {
            font-size: 18px;
            font-weight: 600;
            & + i {
                margin-top: 2px;
                margin-left: 10px;
            }
        }
    }
    .merchant-account-dropdown {
        min-width: 300px;
    }
    .sold-by-dropdown {
        min-width: 300px;
        margin: 0px 0px 50px 0px;
        .header {
            min-height: 40px;
            height: auto;
            padding: 9px 8px;
        }
        .options-menu {
            transform: translate(0px, 50px);
        }
        .logo-in-dpdn {
            height: 35px;
            width: 35px;
            border-radius: 50%;
        }
        .select-header-icon {
            transform: translate(0px, 10px);
            height:unset;
        }
        .select-header-span {
            padding: 0px;
            /* min-height:35px; */
        }
        .dropdown-option-list{
            max-height: 85px;
        }
    }
    .pl-rendered-section {
        margin-left: 50px;
    }
    .pl-navpills .nav-item {
        a {
            width: 200px;
        }
    }
    .purchase-link-select {
        .select-header-span {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }
`;
